// extracted by mini-css-extract-plugin
export default {"cardList":"ProductList_cardList__yooKw"};